module.exports = __webpack_public_path__ + "577787a103e8ccacbe7fee885b2c44d6.png";